module.exports = {"id":"205630","name":"Luciano Abecasis","rating":"73","photo":"./data/images/photos/2/205630.png","club":{"name":"Godoy Cruz","logo":"./data/images/clubs/GodoyCruz.png"},"positions":["DD","MD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LucianoAbecasis0.json
// module id = 2593
// module chunks = 0